import {
  BriefcaseIcon,
  ClipboardListIcon,
  ClockIcon,
  ExternalLinkIcon,
  ShieldCheckIcon,
} from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import { Layout } from '../components/Layout.js';

interface HandigeLink {
  name: string;
  href: string;
  description: string;
  Icon: LucideIcon;
}

// Externe systemen die SUPPOHRT gebruikt. Bewust alleen verwijzingen: geen
// integratie of data-inname, de links openen het externe systeem in een
// nieuw tabblad (zie issue #17 / CONTEXT.md "Handige links").
const LINKS: HandigeLink[] = [
  {
    name: 'TimeChimp',
    href: 'https://app.timechimp.com',
    description: 'Tijdregistratie: uren, projecten en declaraties.',
    Icon: ClockIcon,
  },
  {
    name: 'Nmbrs',
    href: 'https://app.nmbrs.nl',
    description: 'HR- en personeelssysteem: loonstroken en medewerkergegevens.',
    Icon: BriefcaseIcon,
  },
  {
    name: 'Doctolib Connect',
    href: 'https://www.siilo.com',
    description:
      'Beveiligde berichtenapp voor zorgverleners (voorheen Siilo). Alleen als verwijzing.',
    Icon: ShieldCheckIcon,
  },
  {
    name: 'Dialog',
    href: 'https://app.dialog.nl/account/login',
    description: 'Evaluatieformulieren voor de POH-GGZ.',
    Icon: ClipboardListIcon,
  },
];

export function HandigeLinksPage(): JSX.Element {
  return (
    <Layout>
      <div className="mx-auto w-full max-w-3xl px-4 py-8 sm:px-6">
        <div className="mb-6">
          <div className="text-[11px] font-semibold uppercase tracking-wider text-brand-600">
            Informatie
          </div>
          <h1 className="text-2xl font-bold text-ink-700">Handige links</h1>
          <p className="mt-1 text-[14px] leading-relaxed text-ink-500/80">
            Snel naar de externe systemen die SUPPOHRT gebruikt. Deze links openen in een nieuw
            tabblad. Er wordt niets gekoppeld of ingelezen: je logt in het externe systeem zelf in.
          </p>
        </div>

        <ul className="space-y-3">
          {LINKS.map((link) => (
            <li key={link.name}>
              <a
                href={link.href}
                target="_blank"
                rel="noopener noreferrer"
                className="group flex items-start gap-4 rounded-md border border-brand-100 bg-white p-4 shadow-card transition-colors hover:border-brand-300 hover:bg-brand-50/60"
              >
                <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-brand-50 text-brand-600">
                  <link.Icon size={20} strokeWidth={2} />
                </div>
                <div className="min-w-0 flex-1">
                  <div className="flex items-center gap-1.5">
                    <span className="text-[15px] font-semibold text-ink-700">{link.name}</span>
                    <ExternalLinkIcon
                      size={14}
                      className="text-ink-500/40 transition-colors group-hover:text-brand-600"
                    />
                  </div>
                  <p className="mt-0.5 text-[13px] leading-relaxed text-ink-500/80">
                    {link.description}
                  </p>
                </div>
              </a>
            </li>
          ))}
        </ul>
      </div>
    </Layout>
  );
}
